export function setInfo1(info) {
	return {
		style: {
			hiegh: '8mm',
			fontSize: '5mm'
		},
		children: [
			{
				width: null,
				text: `开发单号:${info.developNo}`
			},
			// {
			// 	width: null,
			// 	text: `辅料名称：${info.materialDesc}`
			// },
			{
				width: null,
				text: `供应商名称：${info.vendorName}`
			}
		]
	}
}

export function setInfo2(info) {
	return {
		style: {
			flexDirection: "column"
		},
		children: [
			{
				children: [
					{
						style: {
							width: '30mm',
							flex: 'none'
						},
						text: '图片',
						propsName: 'imgUrl'
					},
					{
						width: null,
						text: `物料名称`,
						propsName: 'vendorMaterialDesc',
						style: {
              width: "30mm",
              flex: "none"
            }
					},
					{
						width: null,
						text: `供应商物料编号`,
						propsName: 'vendorMaterialDesc'
					},
					{
						width: null,
						text: `规格`,
						propsName: 'stanard'
					},
					{
						width: null,
						text: `纱织规格`,
						propsName: 'yarnStanard'
					},
					{
						width: null,
						text: `成分/材质`,
						propsName: 'composition'
					},
					{
						width: null,
						text: `颜色`,
					},
					{
						width: null,
						text: `单位`,
						propsName: 'baseUnit'
					},
					{
						width: null,
						text: `起定量`,
						propsName: 'minOrderQty'
					},
					{
						width: null,
						style: {
							flexDirection: "column",
							flex: 'none',
							width: '20%',
							height: '24mm'
						},
						contentStyle: { flex: "none", width: "20%" },
						contentChildren: [
							{
								// text: `${info.priceRangeUpper1}至${info.priceRangeFloor1}`,
								text: `0-2999`,
								propsName: 'taxFinishPrice1'
							},
							{
								// text: `${info.priceRangeUpper2}至${info.priceRangeFloor2}`,
								text: `3000-10000`,
								propsName: 'taxFinishPrice2'
							},
							{
								// text: `${info.priceRangeUpper3}至${info.priceRangeFloor3}`,
								text: `10000-30000`,
								propsName: 'taxFinishPrice3'
							},
							{
								// text: `${info.priceRangeUpper3}至${info.priceRangeFloor3}`,
								text: `30000以上`,
								propsName: 'taxFinishPrice3'
							}
						],
						children: [
							{
								width: null,
								text: '税率含税成品单价(单位)'
							},
							{
								children: [
									{
										// text: `${info.priceRangeUpper1}至${info.priceRangeFloor1}`,
										text: `0-2999`,
										propsName: 'taxFinishPrice1'
									},
									{
										// text: `${info.priceRangeUpper2}至${info.priceRangeFloor2}`,
										text: `3000-10000`,
										propsName: 'taxFinishPrice2'
									},
									{
										// text: `${info.priceRangeUpper3}至${info.priceRangeFloor3}`,
										text: `10000-30000`,
										propsName: 'taxFinishPrice3'
									},
									{
										// text: `${info.priceRangeUpper3}至${info.priceRangeFloor3}`,
										text: `30000以上`,
										propsName: 'taxFinishPrice4'
									}
								]
							}
						]
					},
					{
						width: null,
						text: `样板周期`,
						propsName: 'sampleDeliveryDate'
					},
					{
						width: null,
						text: `大货周期`,
						propsName: 'wearDeliveryDate'
					},
					{
						style: {
							width: "40mm",
							flex: "none"
						},
						width: null,
						text: `备注`,
					},
				]
			}
		]
	}
}


export const copySetInfo2 = {
	style: {
		height: "26mm",
		flex: "none"
	},
	children: [
		{
			style: {
				width: "30mm",
				flex: "none"
			},
			width: null,
			text: ''
		},
		{
			width: null,
			text: ``,
			style: {
				width: "30mm",
				flex: "none",
			}
		},
		{
			width: null,
			text: null
		},
		{
			width: null,
			text: null
		},
		{
			width: null,
			text: null
		},
		{
			width: null,
			text: null
		},
		{
			width: null,
			text: null
		},
		{
			width: null,
			text: null
		},
		{
			width: null,
			text: null
		},
		{
			width: null,
			style: {
				flexDirection: "row",
				flex: 'none',
				width: '20%'
			},
			children: [
				{
					width: null,
					text: null
				},
				{
					width: null,
					text: null
				},
				{
					width: null,
					text: null
				},
				{
					width: null,
					text: null
				}
			]
		},
		{
			width: null,
			text: null
		},
		{
			width: null,
			text: null
		},
		{
			style: {
				width: "40mm",
				flex: "none"
			},
			width: null,
			text: null
		},
	]
}

export function setInfo8(info) {
	return {
		style: {
			flexDirection: "column",
			height: '10mm'
		},
		children: [
			{
				children: [
					{
						width: null,
						text: `报价人:${info.createdByName}`
					},
					{
						width: null,
						text: "主任审核:"
					},
					{
						width: null,
						text: "经理复核"
					},
					{
						width: null,
						text: `打印日期:${info.printDate}`
					},
					{
						width: null,
						text: `开发员:${info.developer}`
					}
				]
			}
		]
	}
}
